import React from 'react';
import PropTypes from 'prop-types';

import { faFileInvoiceDollar } from '@fortawesome/pro-solid-svg-icons';

import { connect } from 'react-redux';
import { addStep } from './store/workflow/actions';

import AddControl from 'components/add_control/v2';
import EmptyState from 'shared/empty_state';

const VoucherApprovalWorkflowEmptyState = ({ addStep }) => {
  return (
    <EmptyState
      bodyText='Get started by clicking on the "Add Workflow" button'
      icon={faFileInvoiceDollar}
    >
      <AddControl label="Add Workflow" onClick={addStep} />
    </EmptyState>
  );
};

VoucherApprovalWorkflowEmptyState.propTypes = {
  addStep: PropTypes.func.isRequired,
};

const mapDispatchToProps = {
  addStep,
};

export default connect(null, mapDispatchToProps)(VoucherApprovalWorkflowEmptyState);
